// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"91":"821c5b60","196":"d34febe3","891":"532a137c","924":"6290576f"}[chunkId] + ".css";
};